import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { useGetUnitLeases } from '@/api/units/get-unit-leases'
import { Card } from '@/components/ui/card'
import { RowAction, Table } from '@/components/ui/table'
import { Typography } from '@/components/ui/typography'
import { routerFactory } from '@/factories'
import { UnitLeaseWithResidents } from '@/models/features'

import { getUnitLeasesColumns, UNIT_LEASES_TABLE_ID } from './unit-leases.page.constants'

export const UnitLeasesPage = () => {
  const { t } = useTranslation(['units'])
  const { unitId } = useParams<{ unitId: string }>()
  const { navigate } = routerFactory.useRouter()

  const { data: leases, isLoading, error } = useGetUnitLeases({ unitId: unitId! })

  const rowActions: RowAction<UnitLeaseWithResidents>[] = [
    {
      label: t('units:leases.actions.view'),
      onClick: (lease) =>
        navigate({
          params: { leaseId: lease.id, unitId: unitId! },
          path: '/dashboard/units/:unitId/leases/:leaseId',
        }),
      primary: true,
    },
  ]

  return (
    <Card>
      <Typography as="h2" size="heading-small" color="black800">
        {t('units:leases.title')}
      </Typography>
      <Table
        id={UNIT_LEASES_TABLE_ID}
        columns={getUnitLeasesColumns({ t })}
        data={leases ?? []}
        emptyDescription={t('units:leases.empty.description')}
        emptyText={t('units:leases.empty.title')}
        error={error}
        getRowKey={(lease) => lease.id}
        loading={isLoading}
        rowActions={rowActions}
      />
    </Card>
  )
}
